import { IProductionFiltersMetadata, RydeUiUnit } from "@ryde/shared";

export const PRODUCTION_LOGS_JOIN_DELIMITER = ", ";

/** Avoid rendering thousands of booking links in production filters metrics. */
export const PRODUCTION_METRICS_BOOKING_IDS_DISPLAY_LIMIT = 35;

export const PRODUCTION_METRICS_FILTER_ID_KEYS: {
  key: keyof IProductionFiltersMetadata;
  entity: RydeUiUnit;
}[] = [
  { key: "siteIds", entity: "site" },
  { key: "areaIds", entity: "area" },
  { key: "unitIds", entity: "unit" },
  { key: "shiftIds", entity: "shift" },
  { key: "passengerTypeIds", entity: "passengerType" },
  { key: "bookingIds", entity: "booking" },
  { key: "filterCourseIds", entity: "course" },
];
